import { ptBR } from '@/i18n/pt-BR';

/** Instrumentos de inspeção visual honesta da E26 (um aberto por vez). */
export type InstrumentKey = 'topography' | 'genesis' | 'matrix';

export interface SegmentedInstrumentSelectorProps {
  active: InstrumentKey | null;
  onToggle: (key: InstrumentKey) => void;
}

interface ChipDef {
  key: InstrumentKey;
  label: string;
}

const CHIPS: ReadonlyArray<ChipDef> = [
  { key: 'topography', label: ptBR.workspaceCaso.topographyChip },
  { key: 'genesis', label: ptBR.workspaceCaso.genesisChip },
  { key: 'matrix', label: ptBR.workspaceCaso.matrixChip },
];

/**
 * Seletor segmentado de uma linha (E29.F1/ADR-0040 §C). Acordeão horizontal: // ux-neutrality:allow doc-comment
 * cada chip é um botão de divulgação (`aria-expanded`) do seu instrumento, e // ux-neutrality:allow doc-comment
 * apenas um fica aberto por vez. Reclicar o chip ativo fecha o painel. // ux-neutrality:allow doc-comment
 * Mantém os testids `{key}-toggle` herdados da E26 — o chip É o toggle agora. // ux-neutrality:allow doc-comment
 */
export function SegmentedInstrumentSelector({
  active,
  onToggle,
}: SegmentedInstrumentSelectorProps): JSX.Element {
  return (
    <div
      className="instrument-selector"
      role="group"
      aria-label={ptBR.workspaceCaso.instrumentSelectorLabel}
    >
      {CHIPS.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          className="instrument-chip"
          data-testid={`${key}-toggle`}
          aria-expanded={active === key}
          aria-controls={`${key}-body`}
          onClick={() => onToggle(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
